<template>
  <v-layout
    row
    wrap>
    <v-flex xs5>
      <product-price
        v-model="price"
        :gross-disabled="grossDisabled"
        :net-disabled="netDisabled"
        :vat="vat"
        horizontal
        net-label="Tier Price"
        gross-label="Gross Tier Price"
      />
    </v-flex>
    <v-flex xs2>
      <v-text-field
        :label="$t('Quantity')"
        v-model.number="tier.quantity"
        outline
      />
    </v-flex>
    <v-flex xs4>
      <v-combobox
        :label="$t('Customer Groups')"
        v-model="tier.customer_groups"
        :items="customerGroups"
        :return-object="false"
        multiple
        chips
        deletable-chips
        small-chips
        outline
        item-text="name"
        item-value="code"
      />
    </v-flex>
    <v-flex xs1>
      <v-btn
        icon
        color="error"
        @click="$emit('removed', tier)"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import ProductPrice from '@/modules/Products/components/ProductPrice'
export default {
  name: 'ProductSingleTierPrice',
  components: { ProductPrice },

  props: {
    value: {
      type: Object,
      default: () => {
        return {
          price: null,
          gross_price: null,
          quantity: 1,
          customer_groups: []
        }
      }
    },
    customerGroups: {
      type: Array,
      required: false,
      default: () => []
    },
    netDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    grossDisabled: {
      type: Boolean,
      required: true
    },
    vat: {
      type: Object,
      default: undefined,
      required: false
    }
  },

  computed: {
    price: {
      get () {
        return {
          price: this.value.price,
          gross_price: this.value.gross_price
        }
      },
      set (value) {
        if (value.price && this.tier.price.amount !== value.price.amount) {
          this.tier.price = value.price || null
        }

        if (value.gross_price && this.tier.gross_price.amount !== value.gross_price.amount) {
          this.tier.gross_price = value.gross_price || null
        }
      }
    },
    tier: {
      get () {
        return this.value
      },
      set (value) {
        this.tier = value
        this.$emit('input', this.tier)
      }
    }
  }
}
</script>
